module.exports = __webpack_public_path__ + "static/media/google.13047607.png";